import React from 'react'
import PropTypes from 'prop-types'
import { Empty } from 'antd'

DataTableBody.propTypes = {
    error: PropTypes.string,
    statics: PropTypes.array
}

function DataTableBody(props) {
    const { error, statics = [] } = props
    // tính tổng cho từng cột
    const totals = Array.isArray(statics) && statics.length > 0 ? statics.reduce((acc, item) => {
        acc.total += Number(item.total) || 0
        acc.pending += Number(item.pending) || 0
        acc.designed += Number(item.designed) || 0
        acc.embroidered += Number(item.embroidered) || 0
        acc.printing += Number(item.printing) || 0
        acc.printed += Number(item.printed) || 0
        acc.transferring += Number(item.transferring) || 0
        acc.transferred += Number(item.transferred) || 0
        acc.confirmed += Number(item.confirmed) || 0
        acc.wait_to_sew += Number(item.wait_to_sew) || 0
        acc.sewing += Number(item.sewing) || 0
        acc.completed += Number(item.completed) || 0
        return acc
    }, {
        total: 0, pending: 0, designed: 0, embroidered: 0, printing: 0, printed: 0,
        transferring: 0, transferred: 0, confirmed: 0, wait_to_sew: 0, sewing: 0, completed: 0
    }) : {
        total: 0, pending: 0, designed: 0, embroidered: 0, printing: 0, printed: 0,
        transferring: 0, transferred: 0, confirmed: 0, wait_to_sew: 0, sewing: 0, completed: 0
    }

    return (
        <tbody className='DataTableBody'>
            {Array.isArray(statics) && statics.length > 0 &&
                <tr key="totals" className='font-weight-bold'>
                    <td></td>
                    <td className='text-center'>{totals.total}</td>
                    <td className='text-center'>{totals.pending}</td>
                    <td className='text-center'>{totals.designed}</td>
                    <td className='text-center'>{totals.embroidered}</td>
                    <td className='text-center'>{totals.printing}</td>
                    <td className='text-center'>{totals.printed}</td>
                    <td className='text-center'>{totals.transferring}</td>
                    <td className='text-center'>{totals.transferred}</td>
                    <td className='text-center'>{totals.confirmed}</td>
                    <td className='text-center'>{totals.wait_to_sew}</td>
                    <td className='text-center'>{totals.sewing}</td>
                    <td className='text-center'>{totals.completed}</td>
                </tr>
            }

            {Array.isArray(statics) && statics.length > 0 ? statics.map(item =>
                    <tr key={item.sku}>
                        <td>{item.sku || ''}</td>
                        <td className='text-center'>{item.total || 0}</td>
                        <td className='text-center'>{item.pending || 0}</td>
                        <td className='text-center'>{item.designed || 0}</td>
                        <td className='text-center'>{item.embroidered || 0}</td>
                        <td className='text-center'>{item.printing || 0}</td>
                        <td className='text-center'>{item.printed || 0}</td>
                        <td className='text-center'>{item.transferring || 0}</td>
                        <td className='text-center'>{item.transferred || 0}</td>
                        <td className='text-center'>{item.confirmed || 0}</td>
                        <td className='text-center'>{item.wait_to_sew || 0}</td>
                        <td className='text-center'>{item.sewing || 0}</td>
                        <td className='text-center'>{item.completed || 0}</td>
                    </tr>
                ) :
                    <tr>
                        <td colSpan={13}>
                            <Empty description="Không có dữ liệu"/>
                        </td>
                    </tr>
            }

            {
                !!error && error.length > 0 && <tr>
                    <td colSpan={13} className='text-danger'>{error}</td>
                </tr>
            }

        </tbody>
    )
}

export default DataTableBody
